// Axios
import axios from "axios";

// Helpers
import Helpers from ".";

// Config
import Config from '../config';

// Stores
import ProductStore from '../mobx/stores/ProductStore';
import ProductCategoryStore from '../mobx/stores/ProductCategoryStore';

const populates = "populate[0]=product_categories&populate[1]=main_image&populate[2]=images&populate[3]=stores&populate[4]=product_unit&populate[5]=currency&populate[6]=currency.current_transaction&populate[7]=currency.stores"

const getProducts = async () => {
    const productsData = ProductStore.products;
    const storeId = localStorage.getItem('storeId');

    if (ProductStore.loadingItemStatus) {
        return; // İşlem devam ediyorsa, tekrar çağırmayı engelle
    }

    if (productsData.page > productsData.pageCount) {
        return; // Sayfa sayısı pageCount'ten büyükse, tekrar çağırmayı engelle
    }

    ProductStore.setLoadingItemStatus(true);

    try {
        const response = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.product}?filters[stores][0]=${storeId}&filters[visible][1]=true&pagination[page]=${productsData.page}&pagination[pageSize]=12&sort=createdAt:desc&${populates}`,
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                }
            }
        );

        response.data.data.forEach((product: any) => {
            if (ProductStore.productDatas[product.id] === undefined) {
                ProductStore.addProductData(product.id, {
                    id: product.id,
                    ...product.attributes
                })
            }

            if (ProductStore.products.content[product.id] === undefined) {
                ProductStore.addProduct(product.id, {
                    id: product.id,
                    ...product.attributes
                })
            }
        });

        ProductStore.setPaginationData(productsData.page + 1, response.data.meta.pagination.pageCount);
    } catch (error) {
        console.log('getProducts:', error);
    }

    ProductStore.setLoadingItemStatus(false);
};

const getCategoryProducts = async (categoryId: number) => {
    const productsData = ProductCategoryStore.productCategories[categoryId];

    const storeId = localStorage.getItem('storeId');

    let categoryFilters: any = [
        `filters[stores][0]=${storeId}`,
        `filters[visible][1]=true`,
        `filters[$or][0][product_categories][id][2]=${categoryId}`
    ];
    let categoryFilterIndex = 2;

    await Promise.all(productsData.child_categories.data.map(async (category: any, index: number) => {
        categoryFilterIndex = categoryFilterIndex + 1;
        categoryFilters.push(`filters[$or][${index + 1}][product_categories][id][2][${categoryFilterIndex}]=${category.id}`);
    }));

    let filters = categoryFilters.join('&');

    if (productsData.page > productsData.pageCount) {
        return; // Sayfa sayısı pageCount'ten büyükse, tekrar çağırmayı engelle
    }

    try {
        const response = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.product}?${filters}&pagination[page]=${productsData.page}&pagination[pageSize]=12&sort=createdAt:desc&${populates}`,
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                }
            }
        );

        response.data.data.forEach((product: any) => {
            if (ProductStore.productDatas[product.id] === undefined) {
                ProductStore.addProductData(product.id, {
                    id: product.id,
                    ...product.attributes
                })
            }

            if (productsData.content[product.id] === undefined) {
                ProductCategoryStore.addProductCategoryItem(categoryId, product.id, {
                    id: product.id,
                    ...product.attributes
                })
            }
        });

        ProductCategoryStore.setPaginationData(categoryId, productsData.page + 1, response.data.meta.pagination.pageCount);
    } catch (error) {
        console.log('getCategoryProducts:', error);
    }
};

const resetCategoryProducts = async () => {
    let productCategories = {};

    await Promise.all(Helpers.objectToArray(ProductCategoryStore.productCategories).map(async (productCategory: any) => {
        productCategories[productCategory.id] = {
            ...productCategory,
            content: {},
            page: 1,
            pageCount: 1
        };
    }));

    ProductCategoryStore.setProductCategories(productCategories);
};

const getProduct = async (id: number) => {
    ProductStore.setLoadingItemStatus(true);
    const storeId = localStorage.getItem('storeId');

    try {
        const response = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.product}?filters[id][0]=${id}&filters[stores][1]=${storeId}&filters[visible][2]=true&${populates}`,
            {
                headers: {
                    Authorization: `Bearer ${Helpers.getUserData().token}`,
                }
            }
        );

        response.data.data.forEach((product: any) => {
            if (ProductStore.productDatas[product.id] === undefined) {
                ProductStore.addProductData(product.id, {
                    id: product.id,
                    ...product.attributes
                })
            }
        });
    } catch (error) {
        console.log('getProduct:', error);
    }

    ProductStore.setLoadingItemStatus(false);
};

const searchProducts = async (resetSearchRecord: boolean = false) => {
    const filters = ProductStore.searchFilterText;

    if (filters !== "") {
        if (resetSearchRecord) {
            ProductStore.resetSearchProducts();

        }

        const searchProductsData = ProductStore.searchProducts;

        if (ProductStore.loadingItemStatus) {
            return; // İşlem devam ediyorsa, tekrar çağırmayı engelle
        }

        if (searchProductsData.page > searchProductsData.pageCount) {
            return; // Sayfa sayısı pageCount'ten büyükse, tekrar çağırmayı engelle
        }

        ProductStore.setLoadingItemStatus(true);

        try {
            const response = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.product}?pagination[page]=${searchProductsData.page}&pagination[pageSize]=12&sort=createdAt:desc${filters}&${populates}`,
                {
                    headers: {
                        Authorization: `Bearer ${Helpers.getUserData().token}`,
                    }
                }
            );

            response.data.data.forEach((product: any) => {
                if (ProductStore.productDatas[product.id] === undefined) {
                    ProductStore.addProductData(product.id, {
                        id: product.id,
                        ...product.attributes
                    })
                }

                if (ProductStore.searchProducts.content[product.id] === undefined) {
                    ProductStore.addSearchProduct(product.id, {
                        id: product.id,
                        ...product.attributes
                    })
                }
            });

            ProductStore.setSearchPaginationData(searchProductsData.page + 1, response.data.meta.pagination.pageCount);
        } catch (error) {
            console.log('searchProducts:', error);
        }

        ProductStore.setLoadingItemStatus(false);
    }
};

const getProductStock = (productData: any) => {
    return productData.stock;
}

const exportHelpers = {
    getProducts,
    getCategoryProducts,
    resetCategoryProducts,
    getProduct,
    searchProducts,
    getProductStock
}

export default exportHelpers;